"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWebSpeechPonyfill;

var _useWebChatUIContext = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useWebSpeechPonyfill() {
  return [(0, _useWebChatUIContext.default)().webSpeechPonyfill];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VXZWJTcGVlY2hQb255ZmlsbCIsInVzZVdlYkNoYXRVSUNvbnRleHQiLCJ3ZWJTcGVlY2hQb255ZmlsbCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVdlYlNwZWVjaFBvbnlmaWxsLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFdlYlNwZWVjaFBvbnlmaWxsIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuaW1wb3J0IHVzZVdlYkNoYXRVSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0VUlDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlV2ViU3BlZWNoUG9ueWZpbGwoKTogW1dlYlNwZWVjaFBvbnlmaWxsXSB7XG4gIHJldHVybiBbdXNlV2ViQ2hhdFVJQ29udGV4dCgpLndlYlNwZWVjaFBvbnlmaWxsXTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVBOzs7O0FBRWUsU0FBU0Esb0JBQVQsR0FBcUQ7RUFDbEUsT0FBTyxDQUFDLElBQUFDLDRCQUFBLElBQXNCQyxpQkFBdkIsQ0FBUDtBQUNEIn0=